import styled from 'styled-components';

export const BaseButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
  border: ${props => props.type === 'secondary' ? `0.1rem solid ${props.textColor}` : 0};
  border-radius: 0.3rem;
  font-size: 1rem;

  &:hover {
    transform: scale(0.95);
    cursor: pointer;
  }
`;

export const IconContainer = styled.div`
  display: inline-block;
`;

export const IconSpacer = styled.div`
  display: inline-block;
  width: 0.5rem;
`;